import React, { useEffect, useState } from "react";
import styles from "./styles.modules.scss";

const getTimeLeft = (timeInMilliseconds: number) => {
    const totalSeconds =
        (timeInMilliseconds > 0 ? timeInMilliseconds : 0) / 1000;
    const totalMinutes = totalSeconds / 60;
    const totalHours = totalMinutes / 60;

    return {
        hours: Math.floor(totalHours),
        minutes: Math.floor(totalMinutes % 60),
        seconds: Math.floor(totalSeconds % 60),
    };
};

const formatDigits = (value: number): string => {
    return value.toString().padStart(2, "0");
};

const AnimatedDigit = ({ digit }: { digit: string }) => {
    const [displayState, setDisplayState] = useState({
        current: digit,
        previous: null as string | null,
        isAnimating: false,
    });

    useEffect(() => {
        if (digit !== displayState.current) {
            setDisplayState({
                current: digit,
                previous: displayState.current,
                isAnimating: true,
            });

            const timer = setTimeout(() => {
                setDisplayState((prev) => ({
                    ...prev,
                    isAnimating: false,
                    previous: null,
                }));
            }, 400);

            return () => clearTimeout(timer);
        }
    }, [digit]);

    return (
        <span className={styles.digitContainer}>
            {displayState.isAnimating && displayState.previous !== null && (
                <span className={`${styles.digit} ${styles.digitOut}`}>
                    {displayState.previous}
                </span>
            )}
            <span
                className={`${styles.digit} ${
                    displayState.isAnimating ? styles.digitIn : ""
                }`}
            >
                {displayState.current}
            </span>
        </span>
    );
};

const AnimatedDigitGroup = ({ value }: { value: string }) => {
    const digits = value.split("");

    return (
        <div className={`digit-group ${styles.digitGroup}`}>
            {digits.map((digit, index) => (
                <AnimatedDigit key={index} digit={digit} />
            ))}
        </div>
    );
};

export const AzurePhoenixTimer = ({
    countdown,
    timerLabel,
}: {
    countdown: number;
    timerLabel?: string;
}) => {
    const { hours, minutes, seconds } = getTimeLeft(countdown);

    return (
        <div className={`azure-phoenix-timer ${styles.azurePhoenixTimer}`}>
            <div className={`countdown ${styles.countdown}`}>
                <AnimatedDigitGroup value={formatDigits(hours)} />
                <span className={`separator ${styles.separator}`}>:</span>
                <AnimatedDigitGroup value={formatDigits(minutes)} />
                <span className={`separator ${styles.separator}`}>:</span>
                <AnimatedDigitGroup value={formatDigits(seconds)} />
            </div>

            {timerLabel && (
                <div className={`label ${styles.label}`}>{timerLabel}</div>
            )}
        </div>
    );
};
